import { WorkOrderPickupsComponent } from './work-orders/pickups/work-order-pickups.component';
import { RoswellStatusComponent } from './roswell-status/roswell-status.component';
import { PurchaseOrderEditorComponent } from './work-orders/purchase-orders/purchase-order-editor.component';
import { ReturnBatchesComponent } from './return-batches/return-batches.component';
import { ProductsPreviewComponent } from './products-preview/products-preview.component';
import { ProductsComponent } from './products/products.component';
import { HoldoverCartonsComponent } from './holdover-cartons/holdover-cartons.component';
import { isDevMode, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { LicenseManager } from 'ag-grid-enterprise';
LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-080514}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Ulaap_Inc}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{ams}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{ams}_need_to_be_licensed___{ams}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{17_July_2026}____[v3]_[01]_MTc4NDI0MjgwMDAwMA==2f392cf4ae2f02dde75b3b835394ea6a');

import { HTTP_INTERCEPTORS, HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';

// CLEAN MATERIAL IMPORTS (Angular 17–compatible)
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LayoutModule } from '@angular/cdk/layout';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

// 3rd Party
import { GoogleMapsModule } from '@angular/google-maps';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ToastrModule } from 'ngx-toastr';

// Interceptors, Guards
import { AuthGuard } from './auth.guard';
import { AuthInterceptor } from './auth.interceptor';

// Routing & Root
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DefaultRedirectComponent } from './default-redirect/default-redirect.component';

// DECLARATIONS (UNCHANGED – exactly your list)
import { AgGridModule } from 'ag-grid-angular';
import { DashboardComponent } from './dashboard/dashboard.component';
import { JensCoolComponentComponent } from './jens-cool-component/jens-cool-component.component';
import { LoginComponent } from './login/login.component';
import { MiguelsCoolComponentComponent } from './miguels-cool-component/miguels-cool-component.component';

import { ContactAccessProfilesComponent } from './admin/contact-access-profiles/contact-access-profiles.component';
import { AssistantContextManagerComponent } from './admin/assistant-context-manager/assistant-context-manager.component';
import { AuthDebugComponent } from './admin/auth-debug/auth-debug.component';
import { PermissionManagerComponent } from './admin/permission-manager/permission-manager.component';
import { SpencerAsnImporterComponent } from './admin/spencer-asn-importer/spencer-asn-importer.component';
import { TechnogymSftpBrowserComponent } from './admin/technogym-sftp-browser/technogym-sftp-browser.component';
import { PaulChatComponent } from './admin/paul/paul-chat.component';
import { PaulCoachingComponent } from './admin/paul/paul-coaching.component';
import { PaulCoachingDetailComponent } from './admin/paul/paul-coaching-detail.component';
import { BeaconDeviceFullDetailsComponent } from './beacon-devices/beacon-device-full-details/beacon-device-full-details.component';
import { BeaconDevicesModalComponent } from './beacon-devices/beacon-devices-modal/beacon-devices-modal.component';
import { BeaconDevicesComponent } from './beacon-devices/beacon-devices.component';
import { BarcodeScannerComponent } from './barcode-scanner/barcode-scanner.component';
import { BooleanFilterComponent } from './boolean-filter/boolean-filter.component';
import { CarrierDeliveryReportComponent } from './carrier-delivery-report/carrier-delivery-report.component';
import { CarrierOrderDetailsComponent } from './carrier-work-orders/carrier-order-details.component';
import { CarrierWorkOrdersComponent } from './carrier-work-orders/carrier-work-orders.component';
import { CustomerWorkOrdersComponent } from './customer-work-orders/customer-work-orders.component';
import { CartonDispositionReportsComponent } from './carton-disposition-reports/carton-disposition-reports.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ConsolidationRowDetailsComponent } from './consolidations/consolidation-row-details/consolidation-row-details.component';
import { ConsolidationsComponent } from './consolidations/consolidations.component';
import { SelectConsolidationCarrierComponent } from './consolidations/select-consolidation-carrier/select-consolidation-carrier.component';
import { ContactAutocompleteComponent } from './contacts/contact-autocomplete/contact-autocomplete.component';
import { ContactCreatorComponent } from './contacts/contact-creator/contact-creator.component';
import { ContactDetailsComponent } from './contacts/contact-details/contact-details.component';
import { ContactFullDetailsComponent } from './contacts/contact-full-details/contact-full-details.component';
import { ContactModalComponent } from './contacts/contact-modal/contact-modal.component';
import { ContactTypeEditorComponent } from './contacts/contact-type-editor/contact-type-editor.component';
import { ContactsComponent } from './contacts/contacts.component';
import { TechnicianManagerComponent } from './contacts/technician-manager/technician-manager.component';
import { DeliveryReportsComponent } from './delivery-reports/delivery-reports.component';
import { DocumentArchiveComponent } from './document-archive/document-archive.component';
import { DropTrailerAppointmentWindowDialogComponent } from './drop-trailers/drop-trailer-appointment-window-dialog.component';
import { DropTrailerFlowDateDialogComponent } from './drop-trailers/drop-trailer-flow-date-dialog.component';
import { DropTrailerFlowManagerDialogComponent } from './drop-trailers/drop-trailer-flow-manager-dialog.component';
import { DropTrailerLadingModalComponent } from './drop-trailers/drop-trailer-lading-modal/drop-trailer-lading-modal.component';
import { DropTrailerNotesModalComponent } from './drop-trailers/drop-trailer-notes-modal/drop-trailer-notes-modal.component';
import { DropTrailerPartnerCarrierCellEditorComponent } from './drop-trailers/drop-trailer-partner-carrier-cell-editor.component';
import { DropTrailerFlagsCellRendererComponent } from './drop-trailers/drop-trailer-flags-cell-renderer.component';
import { DropTrailersProgressBarComponent } from './drop-trailers/drop-trailers-progress-bar.component';
import { DropTrailersComponent } from './drop-trailers/drop-trailers.component';
import { ExceptionReportsComponent } from './exception-reports/exception-reports.component';
import { FreightmancerJrComponent } from './freightmancer-jr/freightmancer-jr.component';
import { FreightmancerComponent } from './freightmancer/freightmancer.component';
import { Freightmancerlvl99Component } from './freightmancerlvl99/freightmancerlvl99.component';
import { FreightCommandShellComponent } from './freight-command/freight-command-shell.component';
import { DispatchFreightModule } from './dispatch-freight/dispatch-freight.module';
import { FullPageOrderMakerComponent } from './full-page-order-maker/full-page-order-maker.component';
import { HotOrderRendererComponent } from './hot-order-renderer/hot-order-renderer.component';
import { IconCellRendererComponent } from './icon-cell-renderer/icon-cell-renderer.component';
import { InventoryManagementComponent } from './inventory-warehouses/inventory-management/inventory-management.component';
import { InventoryWarehousesComponent } from './inventory-warehouses/inventory-warehouses.component';
import { PositionDetailsModalComponent } from './inventory-warehouses/warehouse-area-details/position-details-modal/position-details-modal.component';
import { WarehouseAreaDetailsComponent } from './inventory-warehouses/warehouse-area-details/warehouse-area-details.component';
import { WarehouseCreatorComponent } from './inventory-warehouses/warehouse-creator/warehouse-creator.component';
import { WarehousePositionPackagesComponent } from './inventory-warehouses/warehouse-position-packages/warehouse-position-packages.component';
import { WarehousePositionsComponent } from './inventory-warehouses/warehouse-positions/warehouse-positions.component';
import { WarehouseReportsComponent } from './inventory-warehouses/warehouse-reports/warehouse-reports.component';
import { WarehouseRowDetailsComponent } from './inventory-warehouses/warehouse-row-details/warehouse-row-details.component';
import { LadingDocumentListsComponent } from './lading-document-lists/lading-document-lists.component';
import { LadingOperationsDashboardComponent } from './lading-operations-dashboard/lading-operations-dashboard.component';
import { LadingStatusModalComponent } from './lading-status-modal/lading-status-modal.component';
import { ManageMenuItemsComponent } from './menu-manager/manage-menu-items/manage-menu-items.component';
import { ManageSubMenuItemsComponent } from './menu-manager/manage-sub-menu-items/manage-sub-menu-items.component';
import { ManageSubSubMenuItemsComponent } from './menu-manager/manage-sub-sub-menu-items/manage-sub-sub-menu-items.component';
import { MenuManagerModalComponent } from './menu-manager/menu-manager-modal/menu-manager-modal.component';
import { MenuManagerComponent } from './menu-manager/menu-manager.component';
import { MenuModule } from './menu/menu.module';
import { SiteUpdatesComponent } from './menu/site-updates/site-updates.component';
import { SearchOrAddTechnicianComponent } from './modals/search-or-add-technician/search-or-add-technician.component';
import { PalletRacksModalComponent } from './pallet-racks/pallet-racks-modal/pallet-racks-modal.component';
import { PalletRacksComponent } from './pallet-racks/pallet-racks.component';
import { PCESClientCreatorComponent } from './pces-client-lists/pces-client-creator/pces-client-creator.component';
import { PcesDetailsComponent } from './pces-client-lists/pces-client-details/pces-details.component';
import { PcesClientListsComponent } from './pces-client-lists/pces-client-lists.component';
import { PCESModalComponent } from './pces-client-lists/pces-lists-modal/pces-lists-modal.component';
import { PcesEmailDetailsComponent } from './pces-email-lists/pces-email-details/pces-email-details.component';
import { PcesEmailListsComponent } from './pces-email-lists/pces-email-lists.component';
import { PcesEmailPendingListsComponent } from './pces-email-pending-lists/pces-email-pending-lists.component';
import { PcesTransactionPendingListsComponent } from './pces-transaction-pending-lists/pces-transaction-pending-lists.component';
import { PerformanceReportsComponent } from './performance-reports/performance-reports.component';
import { PoolManagerComponent } from './pool-manager/pool-manager.component';
import { ClientScopesAddComponent } from './pool-points/client-scopes-add/client-scopes-add.component';
import { PoolAddModalComponent } from './pool-points/pool-add-modal/pool-add-modal.component';
import { PoolClientAddModalComponent } from './pool-points/pool-client-add-modal/pool-client-add-modal.component';
import { PoolPointActionsCellRendererComponent } from './pool-points/pool-point-actions-cell-renderer/pool-point-actions-cell-renderer.component';
import { PoolPointDetailsComponent } from './pool-points/pool-point-details/pool-point-details.component';
import { PoolPointModalComponent } from './pool-points/pool-point-modal/pool-point-modal.component';
import { PoolPointsComponent } from './pool-points/pool-points.component';
import { PoolStoreAddModalComponent } from './pool-points/pool-store-add-modal/pool-store-add-modal.component';
import { CarrierSpotQuoteComponent } from './quotes/carrier-spot-quote/carrier-spot-quote.component';
import { FullQuoteDetailsComponent } from './quotes/full-quote-details/full-quote-details.component';
import { QuoteCreatorComponent } from './quotes/quote-creator/quote-creator.component';
import { QuoteDetailsComponent } from './quotes/quote-details/quote-details.component';
import { QuotesComponent } from './quotes/quotes.component';
import { CreateRatesComponent } from './rates/create-rates/create-rates.component';
import { CustomerRateQuoteComponent } from './rates/customer-rate-quote/customer-rate-quote.component';
import { FreightmancersRateFriendComponent } from './rates/freightmancers-rate-friend/freightmancers-rate-friend.component';
import { FuelSurchargeComponent } from './rates/fuel-surcharge/fuel-surcharge.component';
import { GetRatesComponent } from './rates/get-rates/get-rates.component';
import { FscManagerComponent } from './rates/fsc-manager/fsc-manager.component';
import { RateManagerComponent } from './rates/rate-manager/rate-manager.component';
import { ContactSelectionDialogComponent } from './rates/update-rates/contact-selection-dialog/contact-selection-dialog.component';
import { UpdateRatesComponent } from './rates/update-rates/update-rates.component';
import { ViewRateDetailsComponent } from './rates/view-rates/view-rate-details/view-rate-details.component';
import { ViewRatesComponent } from './rates/view-rates/view-rates.component';
import { ScheduledAppointmentsModalComponentComponent } from './scheduled-appointments-modal.component/scheduled-appointments-modal.component.component';
import { SettlementsDashboardComponent } from './settlements-dashboard/settlements-dashboard.component';
import { ScheduledTimeModalComponent } from './scheduled-time-modal/scheduled-time-modal.component';
import { ShipmentDetailsComponent } from './shipment-lists/shipment-details/shipment-details.component';
import { ShipmentFullDetailsComponent } from './shipment-lists/shipment-full-details/shipment-full-details.component';
import { ShipmentListsEditorComponent } from './shipment-lists/shipment-lists-editor/shipment-lists-editor.component';
import { ShipmentListsModalComponent } from './shipment-lists/shipment-lists-modal/shipment-lists-modal.component';
import { ShipmentListsComponent } from './shipment-lists/shipment-lists.component';
import { ShipmentOrderCreatorComponent } from './shipment-lists/shipment-order-creator/shipment-order-creator.component';
import { StoreReportsClientComponent } from './store-reports-client/store-reports-client.component';
import { StoreReportsComponent } from './store-reports/store-reports.component';
import { TestGridComponent } from './test-grid/test-grid.component';
import { TestRatesComponent } from './test-rates/test-rates.component';
import { BlindUploadModalComponent } from './trip-lists/blind-upload-modal/blind-upload-modal.component';
import { CustomRendererComponent, HeaderRendererComponent } from './trip-lists/custom-renderer/custom-renderer.component';
import { FullTripDetailsComponent } from './trip-lists/full-trip-details/full-trip-details.component';
import { TripDetailsComponent } from './trip-lists/trip-details/trip-details.component';
import { TripListsComponent } from './trip-lists/trip-lists.component';
import { TripOrderCreatorComponent } from './trip-lists/trip-order-creator/trip-order-creator.component';
import { TripPackageIntakeComponent } from './trip-package-intake/trip-package-intake.component';
import { TripPackageLabelsComponent } from './trip-package-labels/trip-package-labels.component';
import { TripPackageOperationsComponent } from './trip-package-operations/trip-package-operations.component';
import { TripPackageOperationsDetailComponent } from './trip-package-operations/trip-package-operations-detail.component';
import { TripPrintComponent } from './trip-lists/trip-print/trip-print.component';
import { UserDetailsComponent } from './users/user-details/user-details.component';
import { UserModalComponent } from './users/user-modal/user-modal.component';
import { UsersComponent } from './users/users.component';
import { ActionCellRendererComponent } from './work-orders/action-cell-renderer/action-cell-renderer.component';
import { ConsolidatorComponent } from './work-orders/consolidator/consolidator.component';
import { SelectStopDialogComponent } from './work-orders/consolidator/select-stop-dialog.component';
import { DatePicker } from './work-orders/date-picker/date-picker.component';
import { ExpandEditCellRendererComponent } from './work-orders/expand-edit-cell-renderer/expand-edit-cell-renderer.component';
import { FreightSerialSelectDialogComponent } from './work-orders/freight/freight-serial-select-dialog/freight-serial-select-dialog.component';
import { FreightComponent } from './work-orders/freight/freight.component';
import { ProductLookupDialog } from './work-orders/freight/product-lookup-dialog';
import { DocumentTypeSelectionDialog } from './work-orders/full-order-details/document-type-selection-dialog';
import { FinancialCurrencyEditorComponent } from './work-orders/full-order-details/financial-currency-editor/financial-currency-editor.component';
import { FinancialGridComponent } from './work-orders/full-order-details/financial-grid/financial-grid.component';
import { FinancialModalComponent } from './work-orders/full-order-details/financial-modal/financial-modal.component';
import { FullOrderDetailsComponent } from './work-orders/full-order-details/full-order-details.component';
import { RemoveServiceModalComponent } from './work-orders/full-order-details/remove-service-modal/remove-service-modal.component';
import { SignaturePadComponent } from './work-orders/full-order-details/signature-pad/signature-pad.component';
import { LadingStatusCellEditorComponent } from './work-orders/lading-status-cell-editor/lading-status-cell-editor.component';
import { MapComponent } from './work-orders/map/map.component';
import { NewFinancialsComponent, ReplacePipe } from './work-orders/new-financials/new-financials.component';
import { OrderDetailsComponent } from './work-orders/order-details/order-details.component';
import { TooltipComponent } from './work-orders/tooltip/tooltip.component';
import { ChangingCarrierDialogComponent } from './work-orders/work-order-details/changing-carrier-dialog/changing-carrier-dialog.component';
import { ChangingConsigneeDialogComponent } from './work-orders/work-order-details/changing-consignee-dialog/changing-consignee-dialog.component';
import { ChangingShipperDialogComponent } from './work-orders/work-order-details/changing-shipper-dialog/changing-shipper-dialog.component';
import { DocumentModalComponent } from './work-orders/work-order-details/document-modal/document-modal.component';
import { DocumentTypeSelectionDialog2 } from './work-orders/work-order-details/document-type-selection-dialog2';
import { WorkOrderDetailsComponent } from './work-orders/work-order-details/work-order-details.component';
import { UfosComponent } from './work-orders/ufos/ufos.component';
import { UfosRecordComponent } from './work-orders/ufos/ufos-record.component';
import { WorkOrderEntryComponent } from './work-orders/work-order-entry/work-order-entry.component';
import { WorkOrdersClientComponent } from './work-orders/work-orders-client/work-orders-client.component';
import { WorkOrdersComponent } from './work-orders/work-orders.component';
import { WorkOrdersV2Component } from './work-orders-v2/work-orders-v2.component';
import { WorkOrderPanelComponent } from './work-orders-v2/work-order-panel/work-order-panel.component';
import { WorkOrderStatusFlowDialogComponent } from './work-orders-v2/work-order-status-flow-dialog.component';
import { NewNewFinancialsComponent } from './work-orders/new-new-financials/new-new-financials.component';
import { FlagsCellRendererComponent } from './flags-cell-renderer/flags-cell-renderer.component';
import { ModalCellRendererComponent } from './modal-cell-renderer/modal-cell-renderer.component';
import { LadingStatusNoteComponent } from './modals/lading-status-note/lading-status-note.component';
import { LadingNotesModalComponent } from './modals/lading-notes-modal/lading-notes-modal.component';
import { LaborReviewModalComponent } from './modals/labor-review-modal/labor-review-modal.component';
import { AppointmentWindowModalComponent } from './modals/appointment-window-modal/appointment-window-modal.component';
import { StatusTimelineModalComponent } from './modals/status-timeline-modal/status-timeline-modal.component';
import { TechnicianModalComponent } from './modals/technician-modal/technician-modal.component';
import { ZoneManagerComponent } from './managers/zone-manager/zone-manager.component';
import { ZoneMakerComponent } from './managers/zone-maker/zone-maker.component';
import { ZoneMakerExpertModeComponent } from './managers/zone-maker-expert-mode/zone-maker-expert-mode.component';
import { CustomerFinancialReportComponent } from './financials/customer-financial-report/customer-financial-report.component';
import { DevPriorityHoleComponent } from './dev-priority-hole/dev-priority-hole.component';
import { RoutingStopsComponent } from './managers/contact-relationship-manager/routing-stops/routing-stops.component';
import { RelationshipGridComponent } from './managers/contact-relationship-manager/relationship-grid.component';
import { ContactRelationshipManagerComponent } from './managers/contact-relationship-manager/contact-relationship-manager.component';
import { CargoComponent } from './financials/cargo/cargo.component';

import { FinancialHistoryComponent } from './work-orders/financial-history/financial-history.component';
import { WorkOrderHistoryComponent } from './work-orders/work-order-history/work-order-history.component';
import { UfosHistoryComponent } from './work-orders/ufos-history/ufos-history.component';

@NgModule({
  declarations: [
    RoswellStatusComponent,
    ProductsComponent,
    ReturnBatchesComponent,
    ProductsPreviewComponent,
    AppComponent,
    DefaultRedirectComponent,
    LoginComponent,
    DashboardComponent,
    JensCoolComponentComponent,
    MiguelsCoolComponentComponent,
    IconCellRendererComponent,
    WorkOrdersComponent,
    WorkOrdersV2Component,
    WorkOrderStatusFlowDialogComponent,
    ContactsComponent,
    HotOrderRendererComponent,
    FreightmancerJrComponent,
    OrderDetailsComponent,
    ContactDetailsComponent,
    ShipmentListsComponent,
    TooltipComponent,
    TripListsComponent,
    MapComponent,
    ContactTypeEditorComponent,
    DatePicker,
    DropTrailersComponent,
    DropTrailerAppointmentWindowDialogComponent,
    DropTrailerFlowDateDialogComponent,
    DropTrailerFlowManagerDialogComponent,
    DropTrailerLadingModalComponent,
    DropTrailerNotesModalComponent,
    DropTrailerPartnerCarrierCellEditorComponent,
    DropTrailerFlagsCellRendererComponent,
    DropTrailersProgressBarComponent,
    FullOrderDetailsComponent,
    DeliveryReportsComponent,
    FullPageOrderMakerComponent,
    ContactCreatorComponent,
    ContactModalComponent,
    ShipmentDetailsComponent,
    ShipmentOrderCreatorComponent,
    SignaturePadComponent,
    WorkOrderEntryComponent,
    QuotesComponent,
    QuoteCreatorComponent,
    QuoteDetailsComponent,
    FullQuoteDetailsComponent,
    ExceptionReportsComponent,
    TripDetailsComponent,
    FullTripDetailsComponent,
    TripOrderCreatorComponent,
    TripPackageIntakeComponent,
    TripPackageLabelsComponent,
    TripPackageOperationsComponent,
    TripPackageOperationsDetailComponent,
    CustomRendererComponent,
    HeaderRendererComponent,
    TripPrintComponent,
    StoreReportsComponent,
    CartonDispositionReportsComponent,
    PoolManagerComponent,
    PoolPointsComponent,
    PoolPointDetailsComponent,
    PoolPointModalComponent,
    UsersComponent,
    UserDetailsComponent,
    UserModalComponent,
    ShipmentFullDetailsComponent,
    ShipmentListsEditorComponent,
    ShipmentListsModalComponent,
    MenuManagerComponent,
    MenuManagerModalComponent,
    ManageMenuItemsComponent,
    ManageSubMenuItemsComponent,
    ManageSubSubMenuItemsComponent,
    FinancialModalComponent,
    RemoveServiceModalComponent,
    PerformanceReportsComponent,
    FinancialCurrencyEditorComponent,
    GetRatesComponent,
    CustomerRateQuoteComponent,
    ViewRatesComponent,
    UpdateRatesComponent,
    CreateRatesComponent,
    TestGridComponent,
    ExpandEditCellRendererComponent,
    ActionCellRendererComponent,
    FinancialGridComponent,
    InventoryWarehousesComponent,
    InventoryManagementComponent,
    WarehouseRowDetailsComponent,
    WarehouseAreaDetailsComponent,
    PalletRacksComponent,
    WarehousePositionsComponent,
    WarehouseCreatorComponent,
    PalletRacksModalComponent,
    BooleanFilterComponent,
    LadingStatusModalComponent,
    CarrierDeliveryReportComponent,
    WarehousePositionPackagesComponent,
    PositionDetailsModalComponent,
    PCESClientCreatorComponent,
    PcesClientListsComponent,
    PcesDetailsComponent,
    PCESModalComponent,
    PcesEmailListsComponent,
    PcesEmailDetailsComponent,
    PcesEmailPendingListsComponent,
    PcesTransactionPendingListsComponent,
    ConsolidationsComponent,
    ConsolidationRowDetailsComponent,
    ScheduledAppointmentsModalComponentComponent,
    ScheduledTimeModalComponent,
    TestRatesComponent,
    ViewRateDetailsComponent,
    DocumentTypeSelectionDialog,
    DocumentTypeSelectionDialog2,
    LadingDocumentListsComponent,
    WorkOrderDetailsComponent,
    UfosComponent,
    UfosRecordComponent,
    ChangingShipperDialogComponent,
    ChangingConsigneeDialogComponent,
    ChangingCarrierDialogComponent,
    DocumentModalComponent,
    ContactSelectionDialogComponent,
    FuelSurchargeComponent,
    WorkOrdersClientComponent,
    LadingStatusCellEditorComponent,
    ConsolidatorComponent,
    ConfirmDialogComponent,
    SelectConsolidationCarrierComponent,
    SelectStopDialogComponent,
    NewFinancialsComponent,
    ReplacePipe,
    FreightmancerComponent,
    FreightComponent,
    ProductLookupDialog,
    FreightSerialSelectDialogComponent,
    FreightmancersRateFriendComponent,
    ContactAutocompleteComponent,
    Freightmancerlvl99Component,
    FreightCommandShellComponent,
    StoreReportsClientComponent,
    BlindUploadModalComponent,
    PoolAddModalComponent,
    PoolStoreAddModalComponent,
    PoolClientAddModalComponent,
    ClientScopesAddComponent,
    PoolPointActionsCellRendererComponent,
    ContactFullDetailsComponent,
    WarehouseReportsComponent,
    CarrierSpotQuoteComponent,
    CarrierOrderDetailsComponent,
    CarrierWorkOrdersComponent,
    CustomerWorkOrdersComponent,
    SiteUpdatesComponent,
    ContactAccessProfilesComponent,
    AssistantContextManagerComponent,
    AuthDebugComponent,
    PermissionManagerComponent,
    SpencerAsnImporterComponent,
    HoldoverCartonsComponent,
    TechnogymSftpBrowserComponent,
    PaulChatComponent,
    PaulCoachingComponent,
    PaulCoachingDetailComponent,
    TechnicianManagerComponent,
    SearchOrAddTechnicianComponent,
    BeaconDevicesComponent,
    BeaconDeviceFullDetailsComponent,
    BeaconDevicesModalComponent,
    BarcodeScannerComponent,
    FlagsCellRendererComponent,
    ModalCellRendererComponent,
    StatusTimelineModalComponent,
    TechnicianModalComponent,
    LaborReviewModalComponent,
    AppointmentWindowModalComponent,
    LadingStatusNoteComponent,
    LadingNotesModalComponent,
    NewNewFinancialsComponent,
    ZoneManagerComponent,
    ZoneMakerComponent,
    ZoneMakerExpertModeComponent,
    CustomerFinancialReportComponent,
    DevPriorityHoleComponent,
    LadingOperationsDashboardComponent,
    SettlementsDashboardComponent,
    FscManagerComponent,
    RateManagerComponent,
    DocumentArchiveComponent,
    ContactRelationshipManagerComponent,
    CargoComponent
],
  imports: [
    WorkOrderPickupsComponent,
    FinancialHistoryComponent,
    WorkOrderHistoryComponent,
    UfosHistoryComponent,
    PurchaseOrderEditorComponent,
    MenuModule,
    WorkOrderPanelComponent,
    BrowserModule,
    AppRoutingModule,
    DispatchFreightModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    BrowserAnimationsModule,

    // Clean material imports
    LayoutModule,
    MatIconModule,
    MatListModule,
    MatSelectModule,
    MatButtonModule,
    MatStepperModule,
    MatToolbarModule,
    MatSidenavModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatTabsModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
    MatTooltipModule,
    MatRadioModule,
    MatOptionModule,
    MatTableModule,
    MatGridListModule,
    MatMenuModule,
    MatProgressBarModule,
    MatChipsModule,
    DragDropModule,

    AgGridModule,
    RoutingStopsComponent,
    RelationshipGridComponent,

    // 3rd party
    GoogleMapsModule,
    FontAwesomeModule,
    NgxMatSelectSearchModule,
    NgSelectModule,

    ToastrModule.forRoot(),

    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    AuthGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
